import { createContext } from "react";

const DialogContext = createContext({ isDialogOpen: false, isInDialog: false });

export default DialogContext;
